import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dateFormat, openAlert } from '../../utils/common';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import SectionContainer from '../../components/UI/SectionContainer';
import SortController from '../../components/UI/SortController';
import Spinner from '../../components/UI/Spinner';
import faqService from '../../services/faqService';

const FaqListPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [initList, setInitList] = useState([]);
 
  const navigate = useNavigate();

  const fetchList = async () => {
    setLoading(true);
    try {
      const result = await faqService.getFAQList();
      if (result.success) {
        setList(result.data);
        setInitList(result.data.map(item => item.idx));
      } else {
        openAlert({ description: result.message });
      }
    } catch (e) {
      console.error(e);
      openAlert({ description: '데이터 로드 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
      setSelected([]);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const toggleSelect = idx => {
    setSelected(prev =>
      prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]
    );
  };

  const selectAll = e => {
    if (e.target.checked) setSelected(list.map(i => i.idx));
    else setSelected([]);
  };

  const handleDelete = async () => {
    if (!selected.length) {
      openAlert({ description: '삭제할 게시글을 선택해주세요.' });
      return;
    }
    if (!window.confirm('선택하신 게시글을 정말로 삭제하시겠습니까?')) return;
    setLoading(true);
    try {
      const result = await faqService.deleteFAQ(selected);
      if (result.success) {
        fetchList();
        openAlert({ description: result.message });
      } else {
        openAlert({ description: result.message });
      }
    } catch (e) {
      console.error(e);
      openAlert({ description: '삭제 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleApply = async () => {
    const arr = list.map(i => i.idx);
    if (JSON.stringify(arr) === JSON.stringify(initList)) {
      openAlert({ description: '게시글 순서가 변경되지 않았습니다.' });
      return;
    }
    setLoading(true);
    try {
      // 각 FAQ의 순서를 개별적으로 업데이트
      const updatePromises = list.map((item, index) => 
        faqService.updateSequence(item.idx, index + 1)
      );
      
      const results = await Promise.all(updatePromises);
      const allSuccess = results.every(result => result.success);
      
      if (allSuccess) {
        openAlert({ description: '게시글 순서가 변경되었습니다.' });
        setInitList(arr);
      } else {
        const failedResult = results.find(result => !result.success);
        openAlert({ description: failedResult?.message || '순서 변경에 실패했습니다.' });
      }
    } catch (e) {
      console.error(e);
      openAlert({ description: '순서 변경 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => fetchList();

  return (
    <SectionContainer title="FAQ 관리" className="faq_setting list">
      <div className="search_area">
        <div className="acc_total">
          <h4><b>{list.length}</b>개 검색되었습니다.</h4>
        </div>
        <div className="left">
          <div className="but-flex">
            <button className="btn btn-md primary mr-1" onClick={() => navigate('write')}>작성하기</button>
            <button className="btn btn-lg tertiary" onClick={handleDelete}>삭제</button>
          </div>
        </div>
      </div>
      <Spinner visible={loading} />
      <div className="content_area">
        <div className="table_area col-md-11">
          <div className="table">
            <table className="faq-list-table">
              <thead>
                <tr>
                  <th><input type="checkbox" checked={selected.length === list.length} onChange={selectAll} /></th>
                  <th>No</th>
                  <th style={{ width: '45%' }}>질문</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && !loading && (
                  <tr><td colSpan="4">Faq 내역이 존재하지 않습니다.</td></tr>
                )}
                {list.map((item, i) => (
                  <tr key={item.idx} className={selected.includes(item.idx) ? 'on' : ''}>
                    <td style={{cursor: 'default'}}><input type="checkbox" checked={selected.includes(item.idx)} onChange={() => toggleSelect(item.idx)} /></td>
                    <td style={{cursor: 'default'}}>{i + 1}</td>
                    <td className="un_line clickable" style={{ cursor: 'pointer' }} onClick={() => navigate(`edit/${item.idx}`)}>
                      {item.ques_ko || item.ques_en}
                    </td>
                    <td style={{cursor: 'default'}}>{dateFormat(item.reg_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <SortController
          list={list}
          setList={setList}
          selected={selected}
          handleApply={handleApply}
          handleReset={handleReset}
        />
      </div>
    </SectionContainer>
  );
};

export default FaqListPage;
